const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 24 * 3600;
const HOURS_PER_WEEK = 168;

interface ManualWeeklyEnergyInput {
  peakPowerKw?: number;
  averagePowerKw?: number;
  peaksPerDay?: number | null;
  peaksDurationSeconds?: number | null;
  restDayAveragePowerKw?: number | null;
  workingDaysCount?: number;
  workingHoursStart?: string;
  workingHoursEnd?: string;
}

export const parseTimeToSeconds = (time: string = ''): number | null => {
  const [hourRaw, minuteRaw] = time.split(':');
  if (hourRaw === undefined || minuteRaw === undefined) {
    return null;
  }

  const hour = Number(hourRaw);
  const minute = Number(minuteRaw);

  if (isNaN(hour) || isNaN(minute)) {
    return null;
  }

  return hour * SECONDS_PER_HOUR + minute * 60;
};

export const calculateManualWeeklyStats = ({
  peakPowerKw,
  averagePowerKw,
  peaksPerDay,
  peaksDurationSeconds,
  restDayAveragePowerKw,
  workingDaysCount,
  workingHoursStart,
  workingHoursEnd,
}: ManualWeeklyEnergyInput) => {
  const startSeconds = parseTimeToSeconds(workingHoursStart);
  const endSeconds = parseTimeToSeconds(workingHoursEnd);

  if (
    startSeconds === null ||
    endSeconds === null ||
    averagePowerKw == null ||
    peakPowerKw == null ||
    workingDaysCount == null ||
    startSeconds >= endSeconds
  ) {
    return null;
  }

  const activePeriodSeconds = endSeconds - startSeconds;

  const peaksCount = Math.max(0, Number(peaksPerDay ?? 0));
  const peakDuration = Math.max(0, Number(peaksDurationSeconds ?? 0));
  const totalPeakSeconds = peaksCount * peakDuration;
  const nonPeakSeconds = activePeriodSeconds - totalPeakSeconds;
  const restPowerKw = restDayAveragePowerKw ?? averagePowerKw ?? 0;
  const restPeriodSeconds = SECONDS_PER_DAY - activePeriodSeconds;
  const nonWorkingDaysCount = Math.max(0, 7 - workingDaysCount);

  const energyWorkingDayKwh =
    (peakPowerKw * totalPeakSeconds) / SECONDS_PER_HOUR +
    (averagePowerKw * nonPeakSeconds) / SECONDS_PER_HOUR +
    (restPowerKw * restPeriodSeconds) / SECONDS_PER_HOUR;

  const energyNonWorkingDayKwh = restPowerKw * 24;

  const energyRequiredWeekly = energyWorkingDayKwh * workingDaysCount + energyNonWorkingDayKwh * nonWorkingDaysCount;
  const averagePowerWeekly = energyRequiredWeekly / HOURS_PER_WEEK;

  return {
    energyRequiredWeekly,
    averagePowerWeekly,
  };
};
